import {
  ADMINS_SMART_REPORTS_EDIT_REPORT_PATH,
  ADMINS_SMART_REPORTS_NEW_PATH,
  ADMINS_SMART_REPORTS_PATH,
  ADMINS_SMART_REPORTS_PREVIEW_REPORT_PATH,
  ADMINS_SMART_REPORTS_VIEW_REPORT_PATH,
} from '@/utils/constants';
import { Route, Switch } from 'react-router-dom/cjs/react-router-dom.min';

import { EditSmartReport } from '@/admins/SmartReports/components/EditSmartReport';
import { NewSmartReport } from '@/admins/SmartReports/components/NewSmartReport';
import { SmartReportList } from '@/admins/SmartReports/components/SmartReportList';
import { ViewSmartReport } from '@/admins/SmartReports/components/ViewSmartReport';

export const SmartReports = () => {
  return (
    <Switch path={ADMINS_SMART_REPORTS_PATH}>
      <Route exact path={ADMINS_SMART_REPORTS_PATH} component={SmartReportList} />
      <Route exact path={ADMINS_SMART_REPORTS_NEW_PATH} component={NewSmartReport} />
      <Route exact path={ADMINS_SMART_REPORTS_EDIT_REPORT_PATH} component={EditSmartReport} />
      <Route exact path={ADMINS_SMART_REPORTS_VIEW_REPORT_PATH} component={ViewSmartReport} />
      <Route
        exact
        path={ADMINS_SMART_REPORTS_PREVIEW_REPORT_PATH}
        render={(props) => <ViewSmartReport isPreview {...props} />}
      />
    </Switch>
  );
};
